import { Box, Typography } from "@mui/material";
import pjson from "../../../../../package.json";

export interface WatermarkProps {
  env?: string;
}

export const Watermark = ({ env }: WatermarkProps) => {
  return (
    <Box display="flex" justifyContent="flex-end" ml="auto">
      {env && (
        <>
          <Typography component="b" fontWeight="bold">
            Env:
          </Typography>
          {env} &nbsp;
        </>
      )}
      <Typography component="b" fontWeight="bold">
        Vers:
      </Typography>
      <Typography>{pjson.version}</Typography>
    </Box>
  );
};
